<template>
  <div class="article-box">
    <h5>办公环境</h5>
    <hr>

    <div id="article_content" v-html="data">

      <!--<p><img width="100%" src="../assets/img/31de202e2bf33529c4c98148c2c403f1.png" title="前台.png" alt="前台.png"></p>
      <p><img width="100%" src="../assets/img/c08dd722ef5654ca540e6621ba0dd7d4.jpg" title="7208.jpg" alt="7208.jpg"></p>
      <p><img width="100%" src="../assets/img/63fe7f63407b132f62df903181427ed8.jpg" title="O[L_W2EU@U]0U{E5BJL])JN.jpg" alt="O[L_W2EU@U]0U{E5BJL])JN.jpg"><img width="100%" src="../assets/img/4d3007fce0c4021abf691ffc1c6958ac.png" title="bghj_03.png" alt="bghj_03.png"></p>-->

    </div>
    <!---->


    <!--                    -->
  </div>
</template>

<script>
    export default {
      name: "helpoffice",
      data(){
        return{
          data:''
        }
      },
      methods:{
        getData(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                'nozzle': 'protocol',
                'type': 15,
              }
            })  .then(res => {
            let resData = res.data;
            if (res.data.code == 1) {
              that.data = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(that.$t(res.data.msg));
            }
          });
        }
      },
      mounted() {
        this.getData();
      }
    }
</script>

<style scoped>
  @import url("./../assets/css/style.css");
  *{
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 13px;
  }
  h5{
    font-size: 20px;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/components/helpoffice.vue